// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "FIELD_DEF.cataloged": "Catalogado",
  "FIELD_DEF.catalogedBy": "Catalogado por",
  "FIELD_DEF.colorMode": "Modo de color",
  "FIELD_DEF.isPanoramic": "Panorámica",
  "FIELD_DEF.created": "Creado",
  "FIELD_DEF.directoryPath": "Ruta de directorios",
  "FIELD_DEF.documentText": "Texto del documento",
  "FIELD_DEF.ExtensionWin": "Extension_NOLOC_es",
  "FIELD_DEF.filename": "Nombre de archivo",
  "FIELD_DEF.fileDescription": "Descripción",
  "FIELD_DEF.fileSize": "Tamaño de archivo",
  "FIELD_DEF.geometry": "Geo - Correspondencia",
  "FIELD_DEF.height": "Altura",
  "FIELD_DEF.horizontalResolution": "Resolución horizontal",
  "FIELD_DEF.keywords": "Palabras clave",
  "FIELD_DEF.lastModified": "Modificado",
  "FIELD_DEF.lastUpdated": "Cambiado",
  "FIELD_DEF.aliasMac": "Mac de alias",
  "FIELD_DEF.creatorMac": "Mac de creador",
  "FIELD_DEF.fileTypeMac": "Mac de tipo de archivo",
  "FIELD_DEF.zoneMac": "Mac de zona",
  "FIELD_DEF.multipageCount": "Número de páginas",
  "FIELD_DEF.numBands": "Número de vendas",
  "FIELD_DEF.path": "Ruta",
  "FIELD_DEF.ItemID": "ID de activo",
  "FIELD_DEF.shortFilenameWin": "Nombre de archivo corto Windows",
  "FIELD_DEF.thumbnailSize": "Tamaño de miniatura",
  "FIELD_DEF.updatedBy": "Cambiado por",
  "FIELD_DEF.verticalResolution": "Resolución vertical",
  "FIELD_DEF.volume": "Volumen",
  "FIELD_DEF.watermarked": "Marca de agua",
  "FIELD_DEF.watermarkURL": "URL de marca de agua",
  "FIELD_DEF.width": "Anchura",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "General.OK": "Aceptar",
  "General.Cancel": "Cancelar",
  "General.Save": "Guardar",
  "ABOUT": "Acerca de",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "Versión",
  "ABOUT_EXTENSIS_URL": "www.extensis.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio Server",
  "ABOUT_PORTFOLIO_VERSION": "Versión 9.0",
  "ABOUT_SERVER_TAB": "Servidor",
  "accessOriginals": "Acceder y procesar originales",
  "ACCOUNT_TYPE": "Autenticación",
  "ACCOUNT_TYPE_LDAP": "Servicio de directorios",
  "ACCOUNT_TYPE_MANUAL": "Nativo (incorporado)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "Agregar",
  "addAsset": "Añadir activos",
  "ALL_CATALOGS_GROUP": "Todos los catálogos",
  "API_CODE_REFERENCE": "Referencia de código de API (English)",
  "API_CODE_REFERENCE_URL": "http://doc.extensis.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "Comunidad de programadores",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.extensis.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "Ayuda de Portfolio Administration",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.extensis.com/en/portfolio/administration/{version}/index.htm",
  "API_SECTION_1": "La API de Portfolio ofrece una interfaz común para que los programadores integren catálogos de Portfolio, metadatos de activos y procesamiento de medios en sistemas de empresas, flujos de trabajo personalizados e infraestructuras Web.",
  "API_SECTION_2_PART_1": "Para utilizar la API es necesario disponer de licencias, como se describe en ",
  "API_SECTION_2_PART_2": ". Para ver o editar los datos de licencia, haga clic en 'Licencias' en la aplicación de administración Portfolio Administration.",
  "API_SECTION_2_EULA": "el contrato de usuario final (EULA) de Portfolio",
  "API_SECTION_2_EULA_URL": "http://helpdocs.extensis.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_3": "Más información:",
  "API_TOKEN_CREATE": "Agregar Nuevo Identificador API",
  "APPLY": "Aplicar",
  "APP_PAGE_TITLE": "Administración de Portfolio",
  "ASSETS": "Activos",
  "AT_TIME": "en el momento",
  "AUTHENTICATION_ERROR": "Ha fallado la autenticación del servicio de directorios. Compruebe su nombre de usuario y contraseña.",
  "BACKUP_BACKUP_BUTTON": "Copia de seguridad",
  "BACKUP_BACKUP_LABEL": "Copia de seguridad",
  "BACKUP_BACKUP_NOW_BUTTON": "Hacer copia de seguridad ahora",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Para cambiar la ubicación de la copia de seguridad, desactive en primer lugar el servidor de Portfolio.",
  "BACKUP_CONFIRMATION_VERBIAGE": "¿Hacer copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la copia de seguridad.",
  "BACKUP_DIRECTORY_LABEL": "Almacenar en directorio",
  "BACKUP_DIRECTORY_ERROR_MSG": "El directorio de la copia de seguridad seleccionada no es válido.",
  "BACKUP_EXPLANATION_TEXT_1": "Las copias de seguridad capturan y almacenan de forma segura la base de datos y la configuración del servidor.¡\nIt no hace copias de seguridad de sus archivos de valores originales!",
  "BACKUP_EXPLANATION_TEXT_2": "No se podrá acceder al servidor durante la realización de copias de seguridad.",
  "BACKUP_FILES_LABEL": "Archivos copia de seguridad",
  "BACKUP_FRIDAY_LABEL": "Viernes",
  "BACKUP_MONDAY_LABEL": "Lunes",
  "BACKUP_MOST_RECENT_LABEL": "Copia de seguridad más reciente",
  "BACKUP_NEXT_SCHEDULED_LABEL": "Próxima copia de seguridad programada",
  "BACKUP_NOTIFICATIONS": "Enviar notificaciones de correo electrónico después de las copias de seguridad y restauraciones",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "Las notificaciones de correo electrónico deben estar habilitadas en Ajustes globales > Notificaciones de correo electrónico",
  "BACKUP_PROGRESS_BACKING_UP": "Haciendo copia de seguridad",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "Haciendo copia de seguridad de los datos...",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "Copia de seguridad cancelada",
  "BACKUP_PROGRESS_BACKUP_FAILED": "Error de copia de seguridad",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "Copia de seguridad satisfactoria",
  "BACKUP_PROGRESS_PREFLIGHT": "Comprobando el espacio disponible...",
  "BACKUP_PROGRESS_RESTARTING": "Reiniciando el servidor...",
  "BACKUP_PROGRESS_RESTORE_FAILED": "Error de restauración",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "Restauración satisfactoria",
  "BACKUP_PROGRESS_RESTORING": "Restaurando",
  "BACKUP_PROGRESS_RESTORING_DATA": "Restaurando datos...",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "Apagando el servidor...",
  "BACKUP_PROGRESS_SUMMARY": "Paso {stepNum} de {totalSteps}",
  "BACKUP_RESTORE_BUTTON": "Restaurar a partir del archivo de copia de seguridad...",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "¿Restaurar copia de seguridad ahora? El portfolio estará fuera de línea hasta que se complete la restauración. Se sobrescribirá su base de datos y su configuración actuales.",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "El archivo de copia de seguridad está corrupto. Elija otra copia de seguridad desde la cual restaurar.",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "El disco de la copia de seguridad no tiene suficiente espacio\nto completa.\n\n{requiredSpace} requerida, {availableSpace} disponible.",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "La ubicación de la copia de seguridad configurada actualmente no existe. La ubicación de la copia de seguridad se utiliza para descomprimir el archivo cuando se restaura una copia de seguridad. Por favor, restablezca la ubicación de la copia de seguridad en un directorio válido.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "Hubo un problema con la copia de seguridad. Ver los registros de administrador para más información.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "Hubo un problema con la restauración. Ver los registros de administrador para más información.",
  "BACKUP_RESTORE_LABEL": "Restaurar",
  "BACKUP_RESTORE_TITLE": "Copia de seguridad/Restablecer",
  "BACKUP_RETAIN_LABEL": "Retener",
  "BACKUP_RETAIN_VALUE": "Mantener sólo las {numBackups} copias de seguridad más recientes",
  "BACKUP_SATURDAY_LABEL": "Sábado",
  "BACKUP_SCHEDULE_LABEL": "Programar copias de seguridad",
  "BACKUP_SCHEDULE_VALUE": "en",
  "BACKUP_SUNDAY_LABEL": "Domingo",
  "BACKUP_THURSDAY_LABEL": "Jueves",
  "BACKUP_TUESDAY_LABEL": "Martes",
  "BACKUP_WEDNESDAY_LABEL": "Miércoles",
  "BROWSE": "Examinar",
  "BROWSE_FOLDERS_TITLE": "Buscar en las carpetas del servidor",
  "BROWSE_RECENT_FOLDERS_LABEL": "Carpetas recientes",
  "BROWSE_REFRESH": "Sincronizar elementos",
  "CALL_ATT_BUTTON_BUY_NOW": "Comprar ahora",
  "CALL_ATT_BUTTON_SECONDARY": "Póngase en contacto con el Departamento de ventas para solicitar presupuesto",
  "CALL_ATT_FADEL_BUTTON_MAIN": "Ventas del contacto para más información",
  "CALL_ATT_FADEL_MAIN": "Garantice un uso adecuado de su contenido con licencia, desde imágenes hasta vídeos y todo lo demás. El Portfolio se conecta de forma ininterrumpida con el software de nube FADEL para que pueda ver y entender fácilmente los derechos de uso asociados con sus activos, ayudándole a desatascar el flujo de trabajo y reducir el riesgo de infracciones costosas de derechos de autor.",
  "CALL_ATT_FADEL_SUBTITLE": "Conozca los derechos de uso de sus activos",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "Procesamiento y conversión de alto rendimiento",
  "CALL_ATT_ME_MAIN": "¿Desea aprovechar al máximo el rendimiento de su servidor de Portfolio? Con Media Engine, evite la ralentización del servidor y mejore la productividad general eliminando los atascos provocados por entornos de producción con alto rendimiento.\n\n\t• Aumenta la capacidad y productividad\n\t• Desbloquea formatos de producción adicionales\n\t• Acelera la creación de vistas previas de vídeo\n\t• Agregue los Media Engines que necesite\n\t• Configuración de marca de agua (precisa de Media Engine)",
  "CALL_ATT_ME_BUTTON_MAIN": "Obtener Media Engine",
  "CALL_ATT_NP_SUBTITLE": "Portales de auto-servicio para acceder a activos al instante",
  "CALL_ATT_NP_MAIN": "¿Está cansado de solicitudes de última hora cada vez que alguien necesita un activo? Con NetPublish, es fácil publicar sitios web de auto-servicio que permitan a todos ubicar y descargar los activos que necesiten utilizando cualquier navegador en cualquier dispositivo.\n\n\t• Creación de sitios con un solo clic – sin necesidad de HTML o CSS\n\t• Diseño con respuesta de fácil uso en dispositivos móviles\n\t• Control flexible de acceso de usuarios\n\t• Desactive sitios de forma automática\n\t• Configure la resolución, tamaño y formato en la descarga\n\t• Configuración de marca de agua (requiere Media Engine)\n\t• Generación de informes de uso",
  "CALL_ATT_NP_BUTTON_MAIN": "Obtener NetPublish",
  "CALL_ATT_REPORT_TITLE": "Generación de informes para NetPublish",
  "CALL_ATT_REPORT_SUBTITLE": "Información de uso relevante",
  "CALL_ATT_REPORT_MAIN": "¿Desea conocer qué sitios están más activos, qué activos son utilizados y por parte de quién? Con la generación de informes de NetPublish, obtenga la información necesaria para tomar decisiones con información basada en el modo en que Portfolio se está utilizando en su organización.\n\nDesglose de uso por:\n\t• Nombre de sitio NetPublish\n\t• Nombre de usuario\n\t• Nombre de ID de activo\n\t• Fecha y hora",
  "CALL_ATT_REPORT_BUTTON_MAIN": "Obtener NetPublish",
  "CALL_ATT_SK_BUTTON_MAIN": "Probar gratuitamente",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "http://extens.is/p5u9",
  "CALL_ATT_SK_MAIN": "¿Busca una manera de acelerar la asignación de palabras clave a imágenes? Con Portfolio Smart Keywords podrá asignar automáticamente palabras clave “inteligentes” a sus imágenes con un solo clic. Desarrollado por Clarifai, una innovadora empresa de inteligencia artificial que destaca en la tecnología de reconocimiento visual, ofrece una lista de palabras clave sugeridas en cuestión de segundos.\n\n\t• Ofrece una lista de smart keywords en cuestión de segundos\n\t• Ahorra tiempo y recursos reduciendo la introducción manual de palabras clave\n\t• Crea una clasificación consistente en su organización\n\t• Facilita la búsqueda rápida de activos digitales",
  "CALL_ATT_SK_SUBTITLE": "Automatice las palabras clave de sus imágenes",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keywords",
  "CALL_ATT_SSO_SUBTITLE": "Experiencia de usuario ininterrumpida en todas las plataformas",
  "CALL_ATT_SSO_TITLE": "Single Sign-On",
  "CALL_ATT_SSO_MAIN": "¿Es complicado para el personal de su organización mantener organizadas sus credenciales de registro? Por lo general, con las nuevas soluciones aparecen gastos extra de gestión de cuentas de usuario, tanto para usted como para los usuarios.\n\nPor suerte, Portfolio admite Single Sign-On con Active Directory. Al utilizar Single Sign-On, los usuarios pueden registrarse en Portfolio de forma automática desde su sitio de Intranet, lo que les proporciona una experiencia de usuario continua.\n\n\t• Admite el Directorio Activo de Servidor de Windows\n\t• Mejora la seguridad general\n\t• Simplifica la gestión de usuarios\n\t• Mejora la experiencia de usuario",
  "CALL_ATT_SSO_BUTTON_MAIN": "Obtener Single Sign-On",
  "CALL_ATT_URL_BUY_NOW": "https://secure.extensis.com/portfolio-options?lang=es",
  "CALL_ATT_URL_CONTACT_SALES": "http://extensis.com/es/portfolio/contact-me",
  "canEmbedMetadata": "Incrustar metadatos",
  "canImportMetadata": "Importar/Exportar datos",
  "canManageFieldLists": "Gestionar listas de campos públicos",
  "canManagePublicGallery": "Gestionar galerías públicas",
  "canModifyFolderStructure": "Modificar estructuras de carpeta",
  "canMoveAssets": "Mover activos",
  "canPublishNetPublishSites": "Puede publicar sitios NetPublish",
  "canSmartKeyword": "Puede utilizar Smart Keywords",
  "CANCEL": "Cancelar",
  "CATALOG": "Catálogo",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "Hacer socio",
  "CATALOG_BACKUP": "Copia de seguridad del catálogo seleccionado",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "Cambiar Roles",
  "CATALOG_CREATE": "Agregar catálogo nuevo",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "Los administradores de catálogos pueden agregar carpetas de sincronización automática desde el cliente de escritorio (Desktop Client).",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "Crear una carpeta de sincronización automática",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "Plantilla de catálogo",
  "CATALOG_TYPE_GENERAL": "General Use",
  "CATALOG_TYPE_SIMPLE": "Simple",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "Bases de datos",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "Ha surgido un error al crear la carpeta {folder}.",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "Las carpetas predeterminadas de sincronización automática y de vistas previas pueden configurarse en la configuración global.",
  "CATALOG_CREATE_NAME": "Nombre",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "Las vistas previas pueden configurarse en los detalles del catálogo.",
  "CATALOG_CREATE_PREVIEW_FOLDER": "Guarde las vistas previas para que sean más rápidas",
  "CATALOG_CREATE_SHOW_DATABASES": "Mostrar bases de datos",
  "CATALOG_CREATE_USE_VERSIONING": "Utilizar Adjudicación de versión de activo",
  "CATALOG_DELETE": "Eliminar catálogo",
  "CATALOG_DELETE_CONFIRM": "¿Desea eliminar el catálogo seleccionado?",
  "CATALOG_DETAILS": "Detalles del catálogo",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "Para cambiar el nombre de este catálogo, tenemos que sacarlo de línea un momento, ¿Desea continuar?",
  "CATALOG_DETAILS_COLLATION": "Intercalado",
  "CATALOG_DETAILS_COLLATION_NA": "N/A",
  "CATALOG_DETAILS_CREATION_DATE": "Fecha de creación",
  "CATALOG_DETAILS_DATABASE_TAB": "General",
  "CATALOG_DETAILS_FILETYPES_TAB": "Tipos de archivo",
  "CATALOG_DETAILS_LAST_MODIFIED": "Última modificación",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "Usuarios conectados",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "Registros",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "Socios",
  "CATALOG_DETAILS_SIZE_ON_DISK": "Tamaño en disco",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "El usuario administrador se desconectará. ¿Continuar?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "Bloqueado para administración",
  "CATALOG_DETAILS_UNLOCK": "Desbloquear",
  "CATALOG_EXPLANATION_VAULT_1": "Los catálogos de Bóveda almacenan activos en un emplazamiento seguro.",
  "CATALOG_EXPLANATION_VAULT_2": "Los catálogos de Bóveda admiten el bloqueo, adjudicación de versión, salida y registro.",
  "CATALOG_EXPLANATION_WF_1": "Los catálogos de Carpeta de observación efectúan el rastreo de activos de su sistema de archivos.",
  "CATALOG_EXPLANATION_WF_2": "Los catálogos de Carpeta de observación admiten AutoSync.",
  "CATALOG_FILES_TAB_TITLE": "Procesar",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "Para añadir campos al formulario de subida, arrástrelos desde la lista de campos.",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "Campos del formulario de subida",
  "CATALOG_INGEST_FIELDS_LABEL": "Campos",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "Encabezado del formulario",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "El encabezado del formulario es opcional y aparece en la parte superior del formulario.",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "El número máximo de campos para añadir al formulario es {maxFields}.",
  "CATALOG_INGEST_TAB_TITLE": "Gestor de Subida",
  "CATALOG_INGEST_USE_INGEST_LABEL": "Usar el gestor de subida",
  "CATALOG_INGEST_REQUIRED_LABEL": "Requerido",
  "CATALOG_IS_CONNECTED": "Conectado",
  "CATALOG_IS_DEFAULT": "Predeterminado",
  "CATALOG_MANAGE_USERS": "Gestionar socios del catálogo",
  "CATALOG_MANAGE_FIELDS": "Administrar Campos de Catálogos",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "Gestionar plantillas de catálogo…",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "Gestionar plantillas de catálogo personalizadas",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "Nombre de plantilla de catálogo",
  "CATALOG_MEMBER": "Socio",
  "CATALOG_NEW_CATALOG_DETAILS": "Detalles del nuevo catálogo",
  "CATALOG_OFFLINE": "Fuera de línea",
  "CATALOG_ONLINE": "En línea",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "Catalogar todos los tipos de archivos",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "En línea",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "Crear palabras claves desde la ruta",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "Nombre de archivo",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "Carpeta principal",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "Nombre de servidor",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "Árbol de carpetas",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "Volumen",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "Exclusiones de archivos y carpetas",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "¿Eliminar el(los) tipo(s) de archivo(s) seleccionado(s)?",
  "CATALOG_TEMPLATES_TITLE": "Plantillas de Catálogo",
  "endsWith": "Termina con",
  "contains": "Contiene",
  "startsWith": "Empieza con",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "¿Eliminar la(s) exclusión(es) seleccionada(s)?",
  "CATALOG_OPTIONS_TAB_TITLE": "Opciones de categorización",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "La ubicación predeterminada es",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "Tamaño mínimo 300 píxeles, tamaño máximo 4.000 píxeles (mayor dimensión)",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "Generar clips para archivos de audio/vídeo",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "Crear vistas previas",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "Guardar vistas previas y clips en esta carpeta",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "Esta ubicación debe ser accesible para el servidor.",
  "CATALOG_PREVIEWS_MAX_PIXELS": "Tamaño máximo de imagen",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "Resolución máxima de vídeo",
  "CATALOG_PREVIEWS_MINUTES": "minutos",
  "CATALOG_PREVIEWS_PIXELS": "píxeles",
  "CATALOG_PREVIEWS_SHORT": "Vistas previas",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "Limitar duración a",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "El proceso de generación de clips puede llevar tiempo.\nPara que tarde menos, seleccione una resolución menor y una duración más corta.",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "Cancelar socio",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.",
  "CATALOG_SAVE_TEMPLATE": "Guardar plantilla de catálogo...",
  "CATALOG_SAVE_TEMPLATE_TITLE": "Guardar plantilla de catálogo",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "La plantilla guardada incluye: todas las configuraciones de campos, mapeados de metadatos y opciones de catálogos.",
  "CATALOG_SELECT_MESSAGE": "No hay catálogo seleccionado",
  "CATALOG_SET_AS_DEFAULT": "Configurar catálogo predeterminado",
  "CATALOG_SK_DEFAULT_SETTINGS": "Configuración por defecto",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "Nivel de fiabilidad",
  "CATALOG_SK_DEFAULT_LABEL": "Recomendado: {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Motores palabras Smart Keywords",
  "CATALOG_SK_LANGUAGES_LABEL": "Idiomas del motor general",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "Número de palabras clave",
  "CATALOG_SK_SETTINGS_LABEL": "Configuración",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "Utilizar Smart Keywords en este catálogo",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "Nuevos activos de palabras clave inteligentes catalogadas",
  "CATALOG_STATUS": "Estado de catálogo",
  "CATALOG_STORAGE_TYPE_LABEL": "Tipo de almacenamiento",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "Carpetas de inspección",
  "CATALOG_STORAGE_TYPE_VAULT": "Bóveda",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CATALOG_TAKE_OFFLINE_SHORT": "Poner fuera de línea",
  "CATALOG_TAKE_ONLINE_SHORT": "Poner en línea",
  "CATALOG_TEMPLATE": "plantilla",
  "CATALOG_TEMPLATE_NAME": "Nombre de plantilla",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "¿Eliminar la plantilla de catálogo seleccionada?",
  "CATALOG_VIEW_DETAILS": "Ver/Editar detalles del catálogo",
  "CERT_CREATE_REQUEST": "Crear solicitud de certificado",
  "CERT_DELETE_CONFIRMATION": "¿Está seguro de que desea eliminar la solicitud de certificado? Esta acción no se puede deshacer.",
  "CERT_DOWNLOAD": "Descargar",
  "CERT_EXPIRATION_DATE": "Fecha de caducidad",
  "CERT_FILE": "Archivo de certificado",
  "CERT_FILE_INT_1": "Certificado intermedio 1",
  "CERT_FILE_INT_2": "Certificado intermedio 2",
  "CERT_FILE_PASSWORD": "Contraseña del certificado",
  "CERT_FILE_PASSWORD_HELP": "Si su certificado tiene contraseña, introdúzcala aquí",
  "CERT_FILE_PROMPT": "Seleccionar...",
  "CERT_FILE_ROOT": "Certificado raíz",
  "CERT_IMPORT": "Importar un certificado",
  "CERT_ISSUER": "Emisor",
  "CERT_OWNER": "Propietario",
  "CERT_PENDING_REQUEST": "Solicitud de certificado pendiente",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "Ya ha creado una solicitud de certificado. Si continúa, se eliminará la solicitud existente.",
  "CERT_IMPORT_SUCCEEDED": "El certificado se ha importado con éxito. Reinicie el servidor Portfolio y los servicios administrativos de Portfolio para comenzar a utilizar el certificado.",
  "CERT_IMPORT_FAILED_READING_PKCS12": "El servidor no pudo leer el certificado PKCS12. Compruebe la contraseña.",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "No se ha podido importar el certificado Intermedio 1.",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "No se ha podido importar el certificado Intermedio 2.",
  "CERT_IMPORT_FAILED_ROOT": "No se ha podido importar el certificado raíz.",
  "CERTIFICATE_FILE_FILTER": "Certificados (p7b, p7, cer, crt, pem, pfx, p12)",
  "CERTIFICATE_STATUS_INVALID": "Certificado no válido",
  "CERTIFICATE_STATUS_SELF_SIGNED": "Certificado no válido: Autofirmado",
  "CERTIFICATE_STATUS_EXPIRED": "Certificado caducado",
  "CERTIFICATE_STATUS_IMPORTED": "Certificado importado",
  "CERTS_TITLE": "Certificado SSL",
  "CHANGE": "Cambiar",
  "CITY_OR_LOCALITY": "Ciudad o localidad",
  "CLEAR_BUTTON_LABEL": "Borrar",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "Se produjo un error de comunicación con el servidor. Esto suele causarlo la antigüedad de los datos en la caché del navegador, pero también podría indicar un problema con el servidor. Póngase en contacto con el administrador si desea más información.",
  "CONFIGURE_DIRECTORY_SERVICE": "Configurar servicio de directorios",
  "CONFIGURE_EMAIL_LINK": "Configurar notificaciones de correo electrónico...",
  "CONFIRM_DELETE_PDL": "¿Eliminar todos los valores predefinidos para este campo?",
  "CONFIRM_DELETE_SERVICE": "¿Eliminar servicio de directorios?\nSe mantendrán los usuarios importados desde el servicio. Sus contraseñas recuperarán los valores anteriormente definidos en Portfolio, o se inhabilitarán si es que no se habían definido anteriormente.",
  "CONFIRM_TRUNCATE_VALUES": "La longitud máxima supera uno o varios valores predeterminados o predefinidos para este campo. ¿Truncar valores?",
  "CONNECTION_REFUSED_ERROR": "Se ha denegado la conexión al servicio de directorios. Compruebe su nombre de host y la configuración del puerto.",
  "CONTAINS": "contiene",
  "CONTINUE": "Continuar",
  "CREATE": "Crear",
  "CREATE_A_CERTIFICATE_REQUEST": "Crear una solicitud de firma de certificado",
  "CREATE_CATALOG": "Crear catálogo",
  "createContactSheet": "Crear PDF",
  "CREATE_USER": "Crear Usuario",
  "CREATED_BY": "Creado por",
  "CREATE_MAPPING": "Crear Correspondencia",
  "CREATE_USER_EXCLUSION_MAPPING": "Usuario de Exclusión",
  "CREATED_ON_DATE": "Fecha de creación",
  "DATE_FORMAT": "DD/MM/YYYY",
  "DATE_FORMAT_ERROR": "Error de configuración: Cadena de formato incorrecto.",
  "DATE_INVALID_CHAR_ERROR": "La fecha contiene caracteres no válidos.",
  "DATE_TIME_FORMAT": "DD/MM/YYYY L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "DD/MM/YYYY L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "Introduzca un día válido para el mes.",
  "DATE_WRONG_LENGTH_ERROR": "Escriba la fecha con el formato:",
  "DATE_WRONG_MONTH_ERROR": "Introduzca un mes entre 1 y 12",
  "DATE_WRONG_YEAR_ERROR": "Introduzca un año entre 0 y 9999",
  "DEFAULT_ACCESS_LEVEL": "Roles predeterminados",
  "DEFAULT_CATALOG": "Catálogo predeterminado",
  "DEFAULT_CATALOG_NONE": "Ninguno",
  "DEFAULT_PORT_NON_SSL": "Puerto predeterminado para no SSL:",
  "DEFAULT_PORT_SSL": "Puerto predeterminado para SSL:",
  "DELETE": "Eliminar",
  "deleteAssetContents": "Eliminar activos originales",
  "deleteAssetFromCatalog": "Eliminar activo del catálogo",
  "DELETE_SOURCE": "Eliminar Fuente",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "¿Eliminar todos los valores? Se eliminarán todos los valores incluyendo los valores jerarquizados.",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "Elimine el valor '{value}'?\n Contiene valores alojados que también se eliminarán.",
  "DELETE_NESTED_VALUE_CONFIRMATION": "¿Eliminar los valores seleccionados? Contienen valores jerarquizados que también se eliminarán.",
  "DELETE_WARNING_BOX_MSG": "Advertencia! La eliminación no puede deshacerse!",
  "DELETE_WARNING_CATALOG_VAULT": "Todos los ficheros en el catálogo serán destruidos.",
  "DIAGNOSTICS_TITLE": "Diagnóstico",
  "DIAGNOSTICS_NO_PROBLEMS": "No se encontraron problemas",
  "DIAGNOSTIC_DATA_TITLE": "Enviar Informe de diagnóstico a Extensis",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "Nombre de Cuenta o Empresa (obligatorio)",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "Nombre de la persona de contacto",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "Número de identificador de Soporte técnico",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "Enviar Informe",
  "DIAGNOSTIC_STATUS_ERROR": "Se ha producido un problema al cargar el informe de diagnóstico el {date}",
  "DIAGNOSTIC_STATUS_SENDING": "Enviando...",
  "DIAGNOSTIC_STATUS_SUCCESS": "Se ha enviado informe de diagnóstico de forma satisfactoria a Extensis el {date}",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "Consultando. Esto puede tardar unos minutos...",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "Imposible conectar con el servicio de directorios. Compruebe el nombre de host y la configuración del puerto.",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "Filtro",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "AD Usuarios y grupos",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "Configuración del servicio de directorio",
  "DIRECTORY_SERVICES_TITLE": "Servicios de directorio",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "Guardar y sincronizar",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "Eliminar mapeo",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Importaciones de usuario Portfolio",
  "DIRECTORY_SERVICE_MAPIINGS": "Elementos de directorio a Correspondencias Portfolio",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "Correspondencias",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "No hay Correspondencias.\n\nPara crear una correspondencia, seleccione un usuario o grupo a la izquierda y haga clic en 'Crear correspondencia'.",
  "DIRECTORY_SERVICES": "Servicios de directorio",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "No es posible eliminar usuarios de servicio de directorios.",
  "DISTRIBUTION_GROUPS": "Grupos de distribución",
  "DOWNLOAD_CERT_PROMPT": "¿Descargar archivo de solicitud de certificado?",
  "DOWNLOAD_COMPLETE_STRING": "Descarga completa.",
  "downloadPreviews": "Descargar vistas previas",
  "EMAIL_ADDRESS": "Dirección de correo electrónico",
  "EMAIL_CONFIG_AUTH_PASSWORD": "Contraseña",
  "EMAIL_CONFIG_AUTH_USERNAME": "Nombre de usuario",
  "EMAIL_CONFIG_ENABLED": "Habilitar notificaciones de correo electrónico",
  "EMAIL_CONFIG_FROM_ADDRESS": "Correo electrónico desde dirección",
  "EMAIL_CONFIG_INVALID_GENERIC": "Configuración de servidor de correo electrónico no válida",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "Servidor de correo electrónico no encontrado",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "Fallo de autenticación del servidor de correo electrónico",
  "EMAIL_CONFIG_MESSAGE": "Cada usuario que desee recibir notificaciones debe tener una dirección de correo electrónico asignada en el panel de usuarios.",
  "EMAIL_CONFIG_SERVER_ADDRESS": "Dirección del servidor SMTP",
  "EMAIL_CONFIG_SERVER_PORT": "Puerto del servidor SMTP",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "Servidor SMTP validado",
  "EMAIL_CONFIG_USE_SSL_TLS": "Utilizar SSL/TLS",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "Utilizar autenticación SMTP",
  "EMAIL_CONFIG_VALIDATE": "Prueba de conexión",
  "EMAIL_CONFIG_VALIDATED": "Servidor de correo electrónico validado",
  "english": "Inglés",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "Árbol completo bajo base de búsqueda",
  "EQUALS": "es igual a",
  "esp.port.admin-web-app": "Portfolio Administrador Puerto HTTP",
  "esp.port.admin-web-app-ssl": "Portfolio Administrador Puerto SSL",
  "esp.port.http": "Portfolio Servidor Puerto HTTP",
  "esp.port.ssl": "Portfolio Servidor Puerto SSL",
  "EXPORT_MENU_STRING": "Exportar valores",
  "FADEL_HOWTO": "Conexión a su cuenta de FADEL:",
  "FALSE_LABEL": "Falso",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "Compruebe que se está ejecutando el servidor de administración en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar esta aplicación.",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "No se puede realizar esta operación mientras la copia de seguridad o restauración está en progreso.",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "La operación no ha funcionado porque el catálogo está en modo de administración.",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "Ya existe un catálogo con ese nombre.",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "Ya existe un usuario con este nombre de cuenta.",
  "FAULT_MSG_DB_IN_USE": "No ha sido posible realizar la operación porque el catálogo está en uso por parte de un administrador.",
  "FAULT_MSG_DELETE_ADMIN": "No puede borrar la cuenta del administrador.",
  "FAULT_MSG_DELETE_SELF": "No puede eliminar su cuenta de usuario.",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "Se ha producido un error inesperado al eliminar la plantilla de catálogo",
  "FAULT_MSG_DUPE_NAME": "Ya existe un objeto con ese nombre. Utilice un nombre distinto.",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "Ya existe un motor de medios con esa dirección y puerto.",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": " No ha funcionado esa operación porque los datos del cliente estaban desfasados.",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "Compruebe que se está ejecutando el servidor en el equipo local en el puerto indicado en la página de puertos. Si no es así, reinicie el servidor y vuelva a cargar la aplicación.",
  "FAULT_MSG_INVALID_SESSION_ID": "Ha caducado su sesión. Necesita volver a iniciar sesión en el servidor.",
  "FAULT_MSG_IS_NOT_LICENSED": "El servidor no tiene licencia para esa operación.",
  "FAULT_MSG_LEGACY_21000": "Ha fallado la operación debido a un error interno desconocido.",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "Ha surgido un error al actualizar la configuración de registro",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "El directorio de registro especificado no existe, no se puede escribir en él, o la ruta no dirige a un directorio.",
  "FAULT_MSG_NO_DIRECTORY": "No existe la ubicación especificada o no es un directorio.",
  "FAULT_MSG_NULL_DESCRIPTION": "Se ha producido un error inesperado, pero no hay ninguna descripción al respecto.",
  "FAULT_MSG_NULL_FAULTEVENT": "Se ha producido un error inesperado, pero no hay detalles al respecto.",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "No ha funcionado esa operación porque usted no tiene suficientes privilegios.",
  "FAULT_MSG_OPERATION_IS_INVALID": "Esa operación no era válida.",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "Se ha producido un error inesperado al dar nuevo nombre a la plantilla de catálogo",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "Se ha producido un error inesperado al guardar la plantilla de catálogo",
  "FAULT_MSG_SERVER_NOT_RUNNING": "El servidor no se está ejecutando.",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "Ha fallado la operación porque el servidor no tiene una licencia del módulo para empresas.",
  "FAULT_MSG_REMOVE_METADATA_DEF": "Error en la eliminación de la definición de metadatos. Puede estar en uso por otros catálogos.",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "El servidor ha devuelto un error con este mensaje: ",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "El servidor ha devuelto un error sin mensaje. ",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "El servidor ha devuelto un error de tipo desconocido y este mensaje:",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "No se pudo conectar al servidor de correo electrónico especificado.",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "No ha funcionado esa operación porque uno de los servicios no tenía el estado esperado.",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "El nombre de usuario o la contraseña que se han indicado no son válidos para la base de datos.",
  "FAULT_MSG_BAD_DB_PORT": "El puerto de base de datos que se ha especificado no es válido.",
  "FAULT_MSG_BAD_DB_HOST": "El nombre de host o el puerto especificado para la base de datos no son válidos.",
  "FIELD_ACTION_ADD": "Agregar nuevo campo personalizado",
  "FIELD_ACTION_DELETE": "Eliminar campo seleccionado",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "Espacios de nombre XMP",
  "FIELD_ACTION_MANAGE_METADATA": "Administrar metadatos",
  "FIELD_ADD_EXTRACT_METADATA": "Añadir mapa de extracción",
  "FIELD_CATEGORY_ALL": "Todos los campos activos",
  "FIELD_CATEGORY_CUSTOM": "Campos personalizados",
  "FIELD_CATEGORY_SYSTEM": "Campos del sistema",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "Película",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "Categoría de campo",
  "FIELD_CATEGORY_FONTSENSE": "Extensis Font Sense",
  "FIELD_DELETE_CONFIRM_MSG": "¿Desea borrar el campo seleccionado?",
  "FIELD_DISABLE_CONFIRM_MSG": "¿Desea deshabilitar el campo seleccionado?",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "Habilitar todos",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "Añadir mapa de extracción",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "Valor predeterminado",
  "FIELD_FORM_LABEL_DISABLED": "(Deshabilitado)",
  "FIELD_FORM_LABEL_EMBED": "Integrar en Metadatos",
  "FIELD_FORM_LABEL_EXTRACT": "Extraer de Metadatos",
  "FIELD_FORM_LABEL_FIELD_NAME": "Nombre del campo",
  "FIELD_FORM_LABEL_FIELD_TYPE": "Tipo de campo",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "Permitir múltiples valores",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "Tiene valores predefinidos",
  "FIELD_FORM_LABEL_HELP_TEXT": "Texto de ayuda",
  "FIELD_FORM_LABEL_MAX": "Máx: {max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "Longitud máxima",
  "FIELD_FORM_LABEL_METADATA_TAG": "Nombre de metadatos",
  "FIELD_FORM_LABEL_METADATA_TYPE": "Tipo de metadatos",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "Permitir sólo valores predefinidos",
  "FIELD_FORM_LABEL_PRECISION": "Precisión",
  "FIELD_FORM_LABEL_PRECISION_MAX": "Máx",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "Valores predefinidos",
  "FIELD_FORM_LABEL_SHOW_TIME": "Mostrar hora",
  "FIELD_FORM_LABEL_USE_METADATA": "Extraer y asignar metadatos",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "Advertencia: Más de un campo se integra en '{metadata}'",
  "FIELD_METADATA_DATA_TYPE_LABEL": "Tipo de datos",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "Está personalizado",
  "FIELD_METADATA_DEFINITIONS_TITLE": "Definiciones de metadatos",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "Confirmar: ¿Eliminar la definición de metadatos?",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "Tipo con múltiples valores",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "Sin múltiples valores",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "Ordenados",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "Sin ordenar",
  "FIELD_METADATA_NAME_LABEL": "Nombre",
  "FIELD_METADATA_NAMESPACE_LABEL": "Espacio de nombres",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "Agregar un Espacio de nombres XMP personalizado...",
  "FIELD_METADATA_TAG_LABEL": "Etiqueta",
  "FIELD_METADATA_TYPE_LABEL": "Tipo",
  "FIELD_MULTIPLE_EMBED_WARNING": "Más de un campo se integra en",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "Se han seleccionado varios campos",
  "FIELD_NAMESPACE_ABBREVIATION": "Abreviatura",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "¿Eliminar el Espacio de nombres XMP personalizado?\nPueden existir Definiciones de campo que utilicen el espacio de nombres.",
  "FIELD_NAMESPACE_URI": "URI de Espacio de nombres",
  "FIELD_NEW_FIELD_NAME": "Nuevo campo",
  "FIELD_NEW_METADATA_TITLE": "Nueva definición de metadatos",
  "FIELD_NEW_NAMESPACE_TITLE": "Nuevo Espacio de nombres XMP personalizado",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "No se ha seleccionado campo",
  "FIELD_PAGE_TITLE": "Administrar campos para catálogo '{catalogName}'",
  "FIELD_REVERT_CONFIRM_MSG": "Confirmar: ¿Revertir el campo?",
  "FIELD_TYPE_BLOB": "Blob",
  "FIELD_TYPE_BOOLEAN": "Booleano",
  "FIELD_TYPE_DATETIME": "Fecha/Hora",
  "FIELD_TYPE_DECIMAL": "Decimal",
  "FIELD_TYPE_LANG_ALT": "Idioma Alt",
  "FIELD_TYPE_NUMBER": "Número",
  "FIELD_TYPE_PICTURE": "Imagen",
  "FIELD_TYPE_STRING": "Cadena",
  "FIELD_TYPE_STRUCTURE": "Estructura",
  "FIELD_TYPE_TEXTBLOCK": "Bloque de texto",
  "FIELD_TYPE_UNKNOWN": "Desconocido",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "Se ha producido un error al subir el archivo al servidor.",
  "FILE_TYPES_SECTION_TITLE": "Tipos de archivo",
  "FILE_TYPES_ERROR_NAME_EXISTS": "El nombre '{name}' coincide con el nombre de un tipo de archivo existente.",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "Restablecer valores predeterminados",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "¿Descartar cambios pendientes?",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "¿Restablecer todos los tipos de archivo a sus valores predeterminados?",
  "FILE_TYPES_ADD_FILE_TYPE": "Añadir tipo de archivo",
  "FILE_TYPES_UPDATE_FILE_TYPE": "Actualizar tipo de archivo",
  "FILE_TYPES_EXTENSIONS": "Extensiones",
  "FILE_WRONG_TYPE_ERROR_MSG": "Este archivo no es un formato compatible. Por favor, seleccione un archivo jpeg, gif o png.",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "Archivos",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "Ya existe un archivo con ese nombre.",
  "FOLDER_PATH_DOES_NOT_EXIST": "No existe la ruta.",
  "FOLDER_PATH_ERROR": "Error",
  "FOLDER_PATH_NOT_VERIFIED": "No se ha verificado la ruta de carpetas.",
  "FOLDER_PATH_PATH": "Ruta",
  "FOLDER_PATH_OPERATION_INVALID": "Operación no válida",
  "FOLDER_PATH_SUCCESS": "Éxito",
  "FOLDER_PATH_TYPE_AUTOSYNC": "sincronización automática",
  "FOLDER_PATH_TYPE_PREVIEW": "vista previa",
  "FOLDER_PATH_UNKNOWN_FAULT": "Fallo desconocido",
  "french": "Francés",
  "FULL_NAME": "Nombre y apellidos",
  "FULLY_QUALIFIED_DOMAIN_NAME": "Nombre de dominio completo",
  "german": "Alemán",
  "DATA_COLLECTION_HELP_URL": "https://help.extensis.com/hc/es/articles/1260804371029",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "Acepto compartir datos de uso de aplicaciones.",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "Ayúdenos a ofrecer las mejores soluciones compartiendo el uso de aplicaciones con nosotros.\n\nAl aceptar, nos ayudará a recopilar información importante que nos guiará hacia futuras mejoras en la calidad y las funciones. La información recopilada nos ayudará a comprender cuáles son las soluciones que necesita.\n\nPuede siempre cambiar de opinión en cualquier momento y dejar de compartir la información.\n\nPara más información acerca de cómo utilizaremos sus datos y retirarse en el futuro, visite nuestra página de artículo de ayuda: ",
  "DATA_COLLECTION_TITLE": "Análisis",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "Crear carpetas de sincronización automática para los catálogos nuevos en esta carpeta",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "Color de fondo",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "Color de fondo de la pantalla de inicio de sesión.",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "Valores predeterminados de catálogo",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "Seleccione archivo",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "Imagen personalizada",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "El tamaño máximo debería ser 2400 x 1350 píxeles.",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "Título personalizado",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "El título que aparece en la pestaña del navegador o marcador.",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "Pantalla de inicio personalizada",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "Roles predeterminados",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "Pantalla predeterminada de login",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "Notificaciones de correo electrónico",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "La ubicación de las carpetas de sincronización automática y de vistas previas debe estar accesible para el servidor.",
  "GLOBAL_SETTINGS_IMAGE_URL": "Enlace",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "Al hacer clic en la imagen la URL se abrirá en otra ventana del navegador.",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "Para realizar cambios, introduzca el servidor o compruebe si ha caducado la licencia del servidor.",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "Guardar vistas previas de nuevos catálogos en esta carpeta",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "Ubicaciones de datos del servidor",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "Arreglo para requisitos particulares de la conexión de la Portfolio",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "Credenciales de registro únicas",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "Introduzca la cuenta de usuario asociada al servicio Portfolio Server para autenticación Kerberos.",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "Carpeta de trabajo temporal",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "La carpeta de trabajo se modificará la próxima vez que se reinicie el servidor. La nueva carpeta se ubicará en: ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "Es necesario reiniciar el servidor para que este cambio surta efecto.",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Configuración de Bóveda de Portfolio",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Carpeta de bóveda de Portfolio:",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Ubicación de bóveda de Portfolio por defecto:",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "Para cambiar esta carpeta, primero detenga Portfolio.",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "Para mover la Bóveda de Portfolio, desactive el servidor en primer lugar.",
  "HELP_URL": "https://helpdocs.extensis.com/es/portfolio/administration/{version}/index.htm",
  "HELP_URL_FADEL": "http://helpdocs.extensis.com/portfolio/{version}/administration/es/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "Nombre de host",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(predeterminado)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "Conexión al servicio de directorio satisfactoria. Configuración guardada.",
  "IMAGE_FILE_FILTER": "Imágenes (jpg, gif, png)",
  "IMPORT_LDAP": "Importar usuarios desde servidor LDAP/AD",
  "IMPORT_LDAP_SPECIFY_SERVER": "Specificare il server LDAP/AD",
  "IMPORT_MENU_STRING": "Importar valores",
  "IMPORT_SOURCE": "Importar fuente",
  "INVALID_DN_SYNTAX_ERROR": "Imposible conectar con el servicio de directorios por un error de sintaxis de ND no válido. Compruebe el nombre de usuario.",
  "japanese": "Japonés",
  "LAST_CERTIFICATE_REQUEST_LABEL": "Última solicitud de certificado",
  "LAST_MODIFIED_BY": "Última modificación por",
  "LAST_MODIFIED_DATE": "Fecha de última modificación",
  "LDAP_ADDRESS": "Dirección del servidor LDAP/AD",
  "LDAP_BIND_USERNAME": "Nombre de usuario de conexión LDAP",
  "LDAP_SYNC_NOTIFICATION": "El servidor ha recibido la solicitud de sincronización.",
  "LIC_ACTIVATE": "Active Portfolio (Se requieren credenciales)",
  "LIC_ADD_MESSAGE": "Copie y pegue licencias o introduzca individualmente una por cada fila.",
  "LIC_ADD_SN": "Agregar licencia nueva",
  "LIC_ADD_SN_SHORT": "Agregar Licencias",
  "LIC_ASSET_CAP_DISPLAY": "Activos",
  "LIC_CLICK_TO_ACTIVATE": "Haga clic para activar Portfolio Server",
  "LIC_CLICK_TO_UPGRADE": "Haga clic para actualizar Portfolio Server",
  "LIC_CLICK_TO_USE": "Haga clic para utilizar Portfolio por un periodo de tiempo limitado",
  "LIC_DAYS_REMAINING": "({days} días restantes)",
  "LIC_DEMO_PERIOD": "Periodo de demostración",
  "LIC_ERROR_MSG": "Número de serie no válido, vuelva a intentarlo. Si el problema persiste, confirme el registro de servidor o póngase en contacto con el administrador.",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "No se puede agregar el número de serie a Portfolio Studio.",
  "LIC_MAINTENANCE_END_DATE": "Fecha de finalización de mantenimiento / suscripción",
  "LIC_SEAT_DISPLAY": "Puestos del usuario",
  "LIC_TRIAL": "Portfolio de prueba (Se requiere número de serie)",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "Su licencia de Portfolio no permite más de un catálogo. Considere actualizar su licencia de Portfolio para poder ejecutar esta acción.",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "Su licencia de Portfolio Server no permite poner más catálogos en línea.",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "Su licencia de Portfolio Server no permite realizar esta acción.",
  "LOGGING_CONFIGURATION": "Configuración de registro",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Para cambiar la ubicación del registro, desactive en primer lugar el servidor de Portfolio.",
  "LOGGING_DEFAULT_LOCATION_MSG": "La ubicación de registro predeterminada es",
  "LOGGING_DIR_MUST_EXIST": "NOTA: Para poder cambiar el directorio de registro, el nuevo directorio que se especifique debe existir ya y debe permitir que escriba en él el usuario bajo el cual se está ejecutando Portfolio Server.",
  "LOGGING_LOG_DIR": "Directorio de registro:",
  "LOGGING_LOG_LEVEL": "Nivel de registro",
  "LOGGING_NUM_LOGS_TO_RETAIN": "Número de registros para conservar",
  "LOGIN": "Iniciar sesión",
  "MAPPING_HEADER": "Asignación de usuario/grupo a cartera",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "Se han modificado las correspondencias, ¿desea guardarlas?",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "No se pudo acceder al motor de medios.",
  "MEDIA_ENGINE_OPERATIONAL": "El media engine es operacional.",
  "MEDIA_ENGINES_ACTION_ADD": "Agregar nuevo motor de medios",
  "MEDIA_ENGINES_ACTION_DELETE": "Eliminar motor de medios",
  "MEDIA_ENGINES_ACTION_EDIT": "Ver/Editar detalles de motor de medios",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "No es posible agregar otro motor de medios activo porque el servidor ya está utilizando el número máximo de motores de medios activos que le permite su licencia de Portfolio Media Engine.",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "No puede agregar un motor de medios porque el servidor no dispone de licencias de Portfolio Media Engine.",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "No puede quitar el motor de medios que viene integrado.",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "Activo",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "Dirección",
  "MEDIA_ENGINES_COLUMN_PORT": "Puerto",
  "MEDIA_ENGINES_COLUMN_TEST": "Probar",
  "MEDIA_ENGINES_CONFIRM_DELETE": "¿Desea eliminar el motor de medios seleccionado?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Detalles del motor de medios",
  "MEDIA_ENGINES_LICENSES_LABEL": "Plazas en el motor de medios disponibles para activación",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "Detalles del nuevo motor de medios",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "No hay motores de medios activos. Debería activar un motor de medios antes de que los clientes necesiten utilizar los servicios de medios de Portfolio.",
  "MOBILE": "Móvil",
  "MOBILE_ENABLED": "Habilitar la carga móvil",
  "MOBILE_FOLDER_VERBIAGE": "Guardar las cargas móviles en esta carpeta:",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "Crear un catálogo nuevo 'Cargas móviles' para ver automáticamente esta carpeta (recomendado)",
  "MOBILE_CATALOG_NAME": "Cargas móviles",
  "modifyAssetContents": "Controle hacia fuera los activos",
  "modifyAssetProperties": "Actualizar campos del activo",
  "MODIFY_LDAP": "Modificar consulta LDAP",
  "NAME": "Nombre",
  "NAME_TOO_LONG_ERROR": "El nombre debe tener menos de 256 caracteres",
  "NAV_ABOUT": "Acerca de",
  "NAV_ACCESS_LEVELS": "Roles",
  "NAV_AUTOSYNC": "Sincronización automática",
  "NAV_BACKUPS": "Copia de seguridad/Restablecer",
  "NAV_CATALOGS": "Catálogos",
  "NAV_GLOBAL_SETTINGS": "Configuración global",
  "NAV_HELP": "Ayuda",
  "NAV_LICENSES": "Licencias",
  "NAV_LOGOUT": "Cerrar sesión",
  "NAV_MEDIA_ENGINES": "Motores de medios",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "Puertos",
  "NAV_REPORTING": "Notificaciones",
  "NAV_SETTINGS": "Configuración",
  "NAV_STATUS": "Estado",
  "NAV_USERS": "Usuarios",
  "NP_SITES": "Sitios NetPublish",
  "NP_SITE_DELETE_LABEL": "Eliminar sitio",
  "NP_SITE_ENABLED_LABEL": "Sitio Habilitado",
  "NO_CATALOGS": "Ninguno",
  "NO_CATALOGS_EXIST": "No existen catálogos.\n\nHaga clic en el botón + para crear un Catálogo.",
  "NO_FILE_SELECTED": "Ningun archivo seleccionado",
  "NO_SITES_EXIST_1": "No existen sitios NetPublish.",
  "NO_SITES_EXIST_2": "Utilice la opción Publicar de Portfolio para crear y publicar sitios.",
  "VaultFolderNotFound": "No se ha encontrado la carpeta Bóveda de Portfolio en {path}.",
  "NO_VAULT_FOLDER": "No se ha encontrado la carpeta Bóveda de Portfolio en {path}.  Verifique la ubicación de la carpeta en su sistema de archivos y en la página Configuración global -> Datos del servidor de esta aplicación.",
  "NOTES": "Notas",
  "NOTIFICATION_FAILURE_ADD": "No se ha podido agregar",
  "NOTIFICATION_SUCCESS_UPDATE": "Actualización con éxito",
  "NOTIFICATION_FAILURE_UPDATE": "Fracasó la actualización",
  "NP_DELETE_SITE_CONFIRMATION": "¿Desea borrar el Sitio de forma permanente?",
  "NP_SOURCE": "Fuente",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "El separador de decimales sólo puede aparecer una vez.",
  "NUMBER_EXCEEDS_MAX_ERROR": "El número introducido es demasiado grande.",
  "NUMBER_INTEGER_ERROR": "El número debe ser entero.",
  "NUMBER_INVALID_CHAR_ERROR": "La entrada contiene caracteres no válidos.",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "Uno de los parámetros de formato no es válido.",
  "NUMBER_LOWER_THAN_MIN_ERROR": "La cantidad introducida es demasiado pequeña.",
  "NUMBER_NEGATIVE_ERROR": "La cantidad no puede ser negativa.",
  "NUMBER_PRECISION_ERROR": "La cantidad introducida tiene demasiados dígitos tras el separador de decimales.",
  "NUMBER_SEPARATION_ERROR": "El separador de miles debe ir seguido de tres dígitos.",
  "OK": "Aceptar",
  "ON_DATE": "en",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "Grupos",
  "ORGANIZATION_NAME": "Nombre de la organización",
  "ORGANIZATIONAL_UNIT": "Unidad organizativa",
  "PASSWORD": "Contraseña",
  "PASSWORD_CONFIRM": "Confirmar contraseña",
  "PASSWORD_TOO_LONG_ERROR": "La contraseña debe tener menos de 256 caracteres",
  "PORT": "Puerto",
  "PORT_VALUE_TOO_HIGH_ERROR": "El valor del puerto debe ser inferior a 65536.",
  "PortfolioAssetCap": "Portfolio Asset Cap",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "Demo",
  "PortfolioDirServices": "Portfolio Directory Services",
  "PortfolioServer": "Portfolio Server",
  "PortfolioStudio": "Portfolio Studio Edition",
  "PortfolioProfessional": "Portfolio Professional Edition",
  "PortfolioEnterprise": "Portfolio Enterprise Edition",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keywords",
  "PortfolioUserConnection": "Portfolio User Connection",
  "PortfolioSingleSignOn": "Single Sign On (SSO)",
  "PORT_TITLE": "Puertos",
  "PORT_DEFAULT": "Predeterminado:",
  "PORT_CURRENT_VALUE": "Valor actual",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "El valor del puerto nuevo tiene que ser un número entre 1 y 65535.",
  "PORT_ERROR_MSG_CONFLICT": "Imposible actualizar los valores de puertos porque uno o varios de los nuevos valores de puerto ya están en uso en el servidor.",
  "PORT_FIND_PORT": "Buscar puerto",
  "PORT_NAME": "Nombre",
  "PORT_NEW_VALUE": "Nuevo valor",
  "PORT_RESTART_NOTICE": "Nota: las actualizaciones de puertos no serán efectivas hasta que se reinicie el servidor.",
  "PORT_RESTART_SERVER": "Reiniciar servidor",
  "PORT_UPDATE_PORTS": "Actualizar puertos",
  "PORT_WARNING_ADMIN_RESTART": "Ha cambiado el puerto de administración. El navegador se redirigirá a la nueva ubicación dentro de {numSecs} segundos.",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "¿Está seguro?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "No ha sido posible crear la carpeta. Introduzca una ruta distinta.",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "Introduzca otra ruta de carpetas, ya que no ha sido posible crear las trayectorias siguientes:",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "No ha sido posible crear esa carpeta porque ya existe un archivo con ese nombre. Introduzca una ruta distinta.",
  "PROMPT_CREATE_THAT_FOLDER": "Esa carpeta no existe. ¿Desea crearla?",
  "PROMPT_CREATE_THESE_FOLDERS": "Estas carpetas no existen. ¿Desea crearlas?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "¿Desea eliminar la licencia seleccionada?",
  "QUERY": "Consulta",
  "REMOVE": "Quitar",
  "REMOVE_DIRECTORY_SERVICE": "Eliminar servicio de directorios",
  "REPLACE_USER_MAPPING_CONFIRMATION": "Ya existe una correspondencia de usuario regular para este usuario. ¿Desea reemplazarla con una correspondencia de usuario de exclusión?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "Ya existe una correspondencia de usuario de exclusión para este usuario. ¿Desea reemplazarla con una correspondencia de usuario regular?",
  "REQUIRED_FIELD_ERROR": "Este campo es imprescindible",
  "REVERT": "Revertir",
  "REVERT_CHANGES": "Invertir Cambios",
  "ROLES_CREATE_ROLE_TITLE": "Crear rol",
  "ROLES_DELETE_CONFIRM": "¿Desea eliminar el nivel de acceso seleccionado?\nLos usuarios con este Rol serán degradados al nivel de Lector.",
  "ROLE_FOR_IMPORT": "Rol para importar",
  "ROLES_PERMISSIONS": "Permisos",
  "ROLES_PERMISSION_ENABLED_HEADER": "Activado",
  "ROLES_PERMISSION_NAME_HEADER": "Operación",
  "SAVE": "Guardar",
  "SAVE_MAPPING": "Guardar Correspondencia",
  "saveOutputSetting": "Gestionar preconfiguraciones convertidas y haga el PDF",
  "SEARCH": "Buscar",
  "SEARCH_BASE": "Buscar en Base",
  "SEARCH_RESULTS": "Resultados de la búsqueda",
  "SECURITY_GROUPS": "Grupos de seguridad",
  "SELECT": "Seleccionar",
  "SEND_DIAGNOSTIC_DATA": "Enviar Informe de diagnóstico a Extensis",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "Ubicación de trabajo predeterminada: ",
  "SERVER_RESTART_REQUIRED": "Es necesario reiniciar el servidor para que surtan efecto los cambios.",
  "SERVER_STATE_ERROR": "Error: Encontrará detalles en el registro de administración",
  "SERVER_STATE_STARTED": "Ejecutando",
  "SERVER_STATE_STARTING": "Iniciando",
  "SERVER_STATE_STOPPED": "Detenido",
  "SERVER_STATE_STOPPING": "Deteniendo",
  "SERVER_STATE_UNKNOWN": "Desconocido",
  "SERVICE_BROWSER": "Examinador de servicios",
  "SK_ENGINE_APPAREL": "Ropa",
  "SK_ENGINE_ART_STYLE": "Estilo de arte",
  "SK_ENGINE_ART_SUBJECT": "Sujeto de arte",
  "SK_ENGINE_ART_MOVEMENT": "Movimiento de arte",
  "SK_ENGINE_CELEBRITIES": "Celebridades",
  "SK_ENGINE_FOOD": "Alimentación",
  "SK_ENGINE_GENERAL": "General",
  "SK_ENGINE_LOGO": "Logotipo",
  "SK_ENGINE_MODERATION": "Moderación",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "Viajes",
  "SK_ENGINE_WEDDINGS": "Bodas",
  "SSL_HANDSHAKE_ERROR": "Fallo en el saludo SSL; verifique que la configuración de puertos y SSL es la correcta.",
  "STARTS_WITH": "comienza con",
  "STATE_OR_PROVINCE": "Estado o provincia",
  "STATUS": "Estado",
  "STATUS_ADMIN_LOG": "Registro de administración",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "Con licencia",
  "STATUS_API_STATE_UNLICENSED": "Sin licencia",
  "STATUS_CLEAR_ADMIN_LOG": "Borrar registro de administración",
  "STATUS_CONNECTED_USERS": "Usuarios conectados",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "Máximo de conexiones",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Motor de medios",
  "STATUS_MEDIA_ENGINES_ACTIVE": "Activo",
  "STATUS_MEDIA_ENGINES_LABEL": "Motores de medios",
  "STATUS_RESTART_SERVER": "Reiniciar Portfolio",
  "STATUS_SEAT_USAGE": "Uso de asientos",
  "STATUS_SERVER_STATE": "Estado de Portfolio",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Iniciar Portfolio",
  "STATUS_STOP_SERVER": "Detener Portfolio",
  "STATUS_PROBLEMS_DETECTED": "Problemas detectados:",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "El espacio restante en el disco de inicio es inferior a {minSpace} GB.",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "La memoria del sistema es {value} GB inferior al requisito mínimo de {minGB} GB.",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "La memoria del sistema calculada por Portfolio es {value}GB. Podría no ser exacta.",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "La carpeta de trabajo no existe o es imposible acceder a ella.",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "El servidor Portfolio no puede escribir en la carpeta de trabajo.",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "El servidor Portfolio no puede leer desde la carpeta de trabajo.",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "El servidor Portfolio no puede crear enlaces simbólicos en la carpeta de trabajo.",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "El espacio restante en el disco de carpetas de trabajo es inferior a {minSpace} GB.",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "No es posible obtener el estado de la carpeta de trabajo.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "El estado del índice de búsqueda elástica {index} es rojo.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "El índice de búsqueda elástica {index} tiene fragmentos no inicializados.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "No están activos todos los fragmentos para el índice de búsqueda elástica {index}.",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "No es posible recuperar el estado de la búsqueda elástica.",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "No es posible recuperar los errores desde el servidor Portfolio.",
  "STATUS_MSG_STARTUP_FAILED": "Se ha producido un error al iniciar",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "No es posible actualizar el estado del servidor.",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "El componente de servidor de agente nativo no se encuentra en ejecución.",
  "SUBJECT_ALTERNATIVE_NAMES": "Nombres de asunto alternativos",
  "SUBMIT": "Enviar",
  "swedish": "Sueco",
  "SYNC_DAILY": "Sincronizar a diario",
  "synchronizeAutoSyncFolder": "Sincronizar carpetas de sincronización automática",
  "SYNCHRONIZE_NOW": "Sincronizar ahora",
  "TARGET_CATALOG": "Catálogo de destino",
  "THIS_LOCALE": "es",
  "TRUE_LABEL": "Verdadero",
  "TOKEN": "Identificador",
  "TOTAL_ASSETS": "Total de activos",
  "TWO_LETTER_COUNTRY_CODE": "Código de país de dos letras",
  "TYPE": "Tipo",
  "UNABLE_CONNECT_LDAP": "Imposible conectar al servidor LDAP/AD.",
  "UNABLE_CONNECT_SERVER": "Imposible conectar al servidor.",
  "UNKNOWN_HOST_ERROR": "Imposible conectarse con el servicio de directorios por una excepción de host desconocido. Compruebe el nombre de host.",
  "UNKNOWN_LDAP_USER_ERROR": "No se encontró ningún usuario en el Servicio de Identidad con el nombre de cuenta '{accountName}'.",
  "useCustomPresets": "Utilizar ajustes de conversión predefinidos",
  "USE_SSL": "Usar SSL",
  "USER_ACCOUNT": "Cuenta",
  "USER_CREATE": "Agregar usuario nuevo",
  "USER_DELETE": "Eliminar usuarios",
  "USER_DELETE_CONFIRM": "¿Eliminar usuarios seleccionados?",
  "USER_DELETE__DELETE_PRIVATE": "Eliminarse permanentemente",
  "USER_DELETE__GALLERY_PROMPT": "La opción Hacer público convierte en públicas todas las galerías privadas y de sólo lectura pertenecientes a este usuario. \"Eliminar todas las galerías privadas\" borra permanentemente todas las galerías privadas y convierte en públicas las galerías de sólo lectura.",
  "USER_DELETE__GALLERY_PROMPT_1": "Los elementos en Salida de los usuarios se revertirán y se podrá acceder a los mismos.",
  "USER_DELETE__GALLERY_PROMPT_2": "Se harán Públicas las Galerías de Sólo lectura de los usuarios.",
  "USER_DELETE__GALLERY_PROMPT_3": "Las Galerías privadas de los usuarios deben:",
  "USER_DELETE__MAKE_PUBLIC": "Hacerse Públicas",
  "USER_DETAILS": "Detalles del usuario",
  "USER_IMPORT": "Importar usuarios",
  "USER_IMPORT_ACCOUNT": "Nombre de cuenta",
  "USER_IMPORT_ACCOUNT_ATTR": "Atributo de cuenta",
  "USER_IMPORT_EMAIL_ATTR": "Atributo de correo electrónico",
  "USER_IMPORT_IMPORT": "Importar",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "Importar usuarios seleccionados",
  "USER_IMPORT_MODIFY_SEARCH": "Modificar búsqueda",
  "USER_IMPORT_NAME_ATTR": "Atributo de nombre de cuenta",
  "USER_IMPORT_NOTES_ATTR": "Atributo de notas",
  "USER_IMPORT_PASSWORD": "Contraseña de la cuenta",
  "USER_IMPORT_PASSWORD_ATTR": "Atributo de contraseña",
  "USER_IMPORT_SEARCH": "Buscar",
  "USER_IMPORT_SEARCH_BASE": "Base de búsqueda",
  "USER_IMPORT_SEARCH_FILTER": "Filtro de búsqueda",
  "USER_IMPORT_SERVER_ADDRESS": "Dirección de servidor",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "Especificar servidor LDAP",
  "USER_LEVEL_ADMINISTRATOR": "Administrador del catálogo",
  "USER_LEVEL_EDITOR": "Editor",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "Publicador",
  "USER_LEVEL_READER": "Lector",
  "USER_MANAGE_CATALOGS": "Gestionar catálogos de usuarios seleccionados",
  "USER_MULT_USERS_SELECTED": "Varios usuarios seleccionados",
  "USER_NAME": "Nombre de usuario",
  "USER_NEW_USER_DETAILS": "Detalles de nuevo usuario",
  "USER_NEW_USER_INFO_MSG": "Para agregar un usuario a catálogos concretos, utilice Catálogos > Usuarios.",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "Agregar  usuarios a todos los catálogos como:",
  "USER_NO_USERS_SELECTED": "No hay usuarios seleccionados",
  "USER_ONLINE": "En línea",
  "USER_PASSWORD_TOO_SHORT": "La contraseña tiene que incluir como mínimo un carácter.",
  "USER_PASSWORDS_DO_NOT_MATCH": "El campo de confirmación de contraseña tiene que concordar con el campo de contraseña.",
  "USER_ROLE": "Nivel de acceso",
  "USER_VIEW_DETAILS": "Ver/Editar detalles de usuario",
  "USERS": "Usuarios",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "El campo no puede superar 255 caracteres.",
  "VALIDATION_MUST_BE_NONEMPTY": "Este campo es imprescindible.",
  "VIEW_EDIT_MAPPINGS": "Ver / Editar correspondencias",
  "AUTH.couldNotConnect": "No fue posible conectar con el servidor. Compruebe la dirección, por favor.",
  "ERROR.serverUnavailable": "El servidor del Portfolio no está disponible.",
  "ERROR.sessionExpired": "La sesión ha caducado.",
  "fileNotFound": "No se encontró el archivo dentro del disco.",
  "ERROR.invalidSearchFailed": "La búsqueda ha fallado porque hubo un problema con la consulta.",
  "AUTH.loginFailed": "Clave de usuario y contraseña incorrectos.",
  "FAULT_CODE.InsufficientPrivileges": "Tiene privilegios insuficientes para realizar esta operación.",
  "unexpectedError": "Ha surgido un error inesperado.",
  "REFRESH": "Actualizar",
  "ALL_CATALOGS": "Todos los catálogos",
  "ALL_SITES": "Todos Los Sitios",
  "ASSET_DOWNLOADS": "Activos - Los más descargados",
  "ASSET_PREVIEWS": "Activos - Los más vistos previamente",
  "ASSET_UPLOADS": "Activos - Cargas",
  "DOWNLOAD_REPORT": "Descargar Reporte",
  "FILE_TYPES": "Tipos de archivo",
  "FROM": "De",
  "SITE": "Sitio",
  "KEYWORD_STATISTICS": "Estadísticas de palabras clave",
  "NETPUBLISH_MOST_DOWNLOADED": "Lo más descargado de NetPublish",
  "NETPUBLISH_USAGE": "Uso de NetPublish",
  "REPORT_NAME_DELETED_BY": "Activos - Eliminaciones",
  "REPORT_NAME_DOWNLOADED_BY": "Activos - Descargas",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "En este informe se identifican los activos cargados, los usuarios que los cargaron, y cuándo.",
  "REPORT_DESCRIPTION_DELETED_BY": "En este informe se identifican los activos eliminados, los usuarios que los han eliminado, y cuándo.",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "En este informe se identifican los activos descargados, los usuarios que los descargaron, y cuándo.",
  "REPORT_DESCRIPTION_DOWNLOADED": "Este informe identifica qué activos han sido descargados y cuántas veces se descargó cada uno.",
  "REPORT_DESCRIPTION_KEYWORD": "Este informe identifica todas las palabras clave del catálogo y a cuántos activos se han aplicado.",
  "REPORT_DESCRIPTION_USAGE": "Este informe identifica qué usuarios han descargado qué activos y cuándo.",
  "REPORT_DESCRIPTION_FILE_TYPES": "Este informe identifica los tipos de archivo más comunes y el espacio en disco que ocupan.",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "Este informe identifica las palabras y frases más comunes que buscan los usuarios.",
  "SEARCH_TERMS": "Buscar términos",
  "TO": "Hasta",
  "VIEW_REPORT": "Ver informe",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "Annulla membership",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "¿Eliminar este usuario del catálogo?\nLos elementos en Salida del usuario se revertirán y se podrá acceder a estos.",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "¿Está seguro de que desea cambiar el rol del usuario en el catálogo? Esta acción puede resultar en la eliminación de los datos del usuario si el nuevo rol tiene acceso o permisos reducidos.",
  "DUPLICATE_FIELD_NAME_ERROR": "Campo Nombre duplicado",
  "EXTENSIS_CONTACT_US_URL": "https://www.extensis.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.extensis.com/hc/en-us/requests/new",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "Para obtener ayuda con la renovación de su cuenta, comuníquese con nosotros al",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "y su Gerente de Éxito del Cliente se comunicará con usted dentro de 1 día hábil.",
  "LIC_ERROR_GET_ACCOUNT": "Surgió un problema al obtener su cuenta Extensis.",
  "LIC_ERROR_GET_LICENSES": "Surgió un problema al recuperar sus licencias de Extensis.",
  "LIC_SET_EXTENSIS_ACCOUNT": "Configure la cuenta Extensis",
  "LIC_SET_ACCOUNT": "Establecer Cuenta",
  "LIC_REMOVE_ACCOUNT": "Eliminar Cuenta",
  "LIC_ACCOUNT": "Dirección de correo electrónico",
  "LIC_PASSWORD": "Contraseña",
  "LIC_SYSTEM_ID": "Identificación del sistema",
  "LIC_SET_ACCOUNT_ERROR": "Surgió un problema al configurar su cuenta Extensis. Revise las credenciales e intente de nuevo.",
  "LIC_SET_SYSTEM_TITLE": "Seleccione su sistema Extensis",
  "PDL_noPredefinedValues": "No hay valores predefinidos",
  "PDL_editPredefinedListPlaceholder": "Editar lista predefinida",
  "PDL_importPredefinedValues": "Importar valores predefinidos",
  "PDL_exportPredefinedValues": "Exportar valores predefinidos",
  "PDL_removeNestedValueConfirmation": "¿Eliminar los valores seleccionados?\nContienen valores anidados que también se eliminarán.",
  "PDL_wrongPdlImportFormat": "El archivo seleccionado no contenía datos de texto. Seleccione un archivo de texto."
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/es.js